import { useState, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import SectionHeading from "../components/sectionHeading";
import { InputField } from "../components/_input/_input";
import { FormButton } from "../components/_input/_button";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import PhoneDropDown, { countriesCode } from "../components/_input/_phoneDropDown";
import "react-tabs/style/react-tabs.css";
import { toast } from "react-toastify";
import axios from "axios";
import config from '../configuration/config';
export default function DeleteAccount() {
  const defaultProfileImage = '/assets/images/profile.jpg';
  const ACCESS_TYPES = { EMAIL: "Email", PHONE: "PhoneNumber" };
  const [accessType, setAccessType] = useState(ACCESS_TYPES.EMAIL);
  const [request, setRequest] = useState({ password: "", validationKey: "" });
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  const [confirmPhone, setConfirmPhone] = useState(false);
  const { t: trans, i18n } = useTranslation(["common", "form", "model", "user", "info", "hints", "error2", "inputs", "new", "extra"]);
  let lang = (i18n.language || 'ar');
  const languageDir = 'language-' + lang;
  // عداد إعادة إرسال الكود + إعادة تعيين عند انتهاء الوقت
  useEffect(() => {
    if (timer <= 0) {
      // إعادة المتغيرات عند انتهاء الوقت
      setConfirmPhone(false);
      setRequest(prev => ({ ...prev, validationKey: "" }));
      return;
    }

    const interval = setInterval(() => setTimer(t => t - 1), 1000);
    return () => clearInterval(interval);
  }, [timer]);

  // إرسال رمز التحقق للهاتف
  const handleSendCode = async () => {
    if (!request?.phone) return toast.error(trans("error2:no_phone_number_error"));

    setLoading(true);
    try {
      const { data } = await axios.post(`${config.controllURL}api/Administration/SendSms`, {
        AccessType: ACCESS_TYPES.PHONE,
        Access: request?.phone
      });

      if (!data) {
        setConfirmPhone(false);
        toast.error(trans("common:failed-access"));
      } else {
        setConfirmPhone(true);
        setTimer(60);
      }
    } catch (err) {
      toast.error(trans("common:failed-access"));
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // حذف الحساب
  const handleDeleteAccount = useCallback(async () => {
    const isPhoneInvalid = accessType === ACCESS_TYPES.PHONE && (!request?.phone || !request.validationKey);
    const isEmailInvalid = accessType === ACCESS_TYPES.EMAIL && (!request?.email || !request.password);

    if (isPhoneInvalid || isEmailInvalid) {
      toast.error(trans("common:failed-access"));
      return;
    }

    if (!window.confirm(trans("user:confirmDeactivateAccount"))) return;

    setLoading(true);
    try {
      const payload = {
        access: accessType === ACCESS_TYPES.EMAIL ? request?.email : request?.phone,
        accessType,
        password: accessType === ACCESS_TYPES.EMAIL ? crypto.MD5(request.password).toString() : undefined,
        validationKey: accessType === ACCESS_TYPES.PHONE ? request.validationKey : undefined,
      };

      const res = await axios.post(`${config.controllURL}api/Administration/DeleteAccount`, payload);

      if (res.status !== 200) throw new Error("Failed");
      deleteAllCookies();
    } catch (err) {
      toast.error(trans("user:accountDeactivationFailed"));
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [accessType, request, trans]);

  // حذف الكوكيز وإعادة التوجيه
  const deleteAllCookies = () => {
    // يمكن تفعيل إزالة الكوكيز وlocalStorage إذا لزم
    document.cookie.split(";").forEach(c => document.cookie = c.split("=")[0] + "=;max-age=-1");
    window.localStorage.clear();
    window.location.href = "/";
  };

  const [showTintingAgreements, setshowTintingAgreements] = useState({
    en: "Notice: Canceling your account will deactivate it and you will not be able to log in.\nYou can reactivate your account anytime by contacting customer support.",
    ar: "تنبيه: سيؤدي إلغاء الحساب إلى تعطيله ولن تتمكن من تسجيل الدخول.\nيمكنك إعادة تفعيل حسابك في أي وقت من خلال التواصل مع خدمة العملاء."
  });


  return (
    <div className={'  mb-3 ' + languageDir}>
         <div className="mt-60  show-xs"></div>
      <div className="container profile-box px-10 py-10 mt-10  rounded-xl nice-shadow-md bg-white">
     

        <SectionHeading
          hasRuler={false}
          title={trans("user:delete_account")}
        >

          {
            showTintingAgreements &&
            <div class="mx-2 mb-5 nice-flex  items-center mt-5 mb-20">
              <img src="/assets/icons/info.svg" class="mx-3 text-inline-block" alt="hassan jameel info " />

              <div class="mx-2 mb-5 nice-flex flex flex-col items-center" style={{ whiteSpace: "pre-line" }}>
                <p class="text-bold text-16  text-gray text-inline-block">  {showTintingAgreements[lang ?? "ar"]} </p>
              </div>
            </div>
          }
          <div className="nice-container-fluid">
            <Tabs
              selectedIndex={accessType === ACCESS_TYPES.EMAIL ? 0 : 1}
              onSelect={index => {
                setAccessType(index === 0 ? ACCESS_TYPES.EMAIL : ACCESS_TYPES.PHONE);
                setRequest({ password: "", validationKey: "" });
                setConfirmPhone(false);
              }}
            >
              <TabList className="react-tabs__tab-list flex text-20 gap-4 mb-4">
                <Tab className="react-tabs__tab text-size-16r">{trans("form:phone")}</Tab>
                <Tab className="react-tabs__tab text-size-16r">{trans("form:email")}</Tab>

              </TabList>

              {/* تبويب الهاتف */}
              <TabPanel>
                <SectionHeading hasRuler={false}>
                  {confirmPhone ? (
                    <div className="nice-card p-4 rounded-xl">
                      <p className="nice-col-md-6 my-5 text-18 text-gray-600">
                        {trans("user:verificationCodeSent")}
                        <strong className="mb-4 text-20 text-gray-600">{request?.phone}</strong>
                      </p>

                      <div className="nice-col-md-6 my-5">
                        <InputField
                          value={request.validationKey}
                          onChangeValue={e => setRequest(prev => ({ ...prev, validationKey: e.target.value }))}
                          title={trans("user:verificationCode")}
                        />
                      </div>
                      <div className="nice-col-md-6 my-5">
                        <FormButton
                          isPrimary
                          isLoading={loading}
                          classes="px-5 py-2"
                          name={trans("user:deleteConfirmation")}
                          onClick={handleDeleteAccount}
                          disabled={!request.validationKey}
                        />
                      </div>
                      <button
                        className={`mt-3 nice-col-md-6 text-sm text-18 underline ${timer > 0 ? "text-gray-400 cursor-not-allowed" : "text-blue-600"}`}
                        onClick={handleSendCode}
                        disabled={timer > 0}
                      >
                        {timer > 0 ? `${trans("new:resend")} (${timer})` : trans("new:resend")}
                      </button>
                    </div>
                  ) : (
                    <div>
                      <p className="nice-col-md-6 my-5 text-18 text-gray-600">
                        {trans("user:sendVerificationCodeToMobile")}
                        <strong className="mb-4 text-20 text-gray-600">{request?.phone}</strong>
                      </p>

                      <div className="nice-col-md-6 flex flex-col nice-gap-2rem">
                        {<> <PhoneDropDown
                          title={trans("user:new_phone_number")}
                          // errorLabel={phoneError?.phoneNumber}
                          onChangeValue={(countryCode, phoneNumber) => setRequest(prev => ({ ...prev, phone: `+${countryCode}${phoneNumber}` }))}

                        />

                        </>}
                      </div>
                      <div className="nice-col-md-6 my-5">
                        <FormButton
                          isPrimary
                          isLoading={loading}
                          classes="px-5 py-2"
                          name={trans("user:sendVerificationCode")}
                          onClick={handleSendCode}
                        />
                      </div>
                    </div>
                  )}
                </SectionHeading>
              </TabPanel>
              {/* تبويب البريد الإلكتروني */}
              <TabPanel>
                <SectionHeading hasRuler={false}>

                  <div className="nice-col-md-6 flex flex-col nice-gap-2rem">

                    <InputField
                      // errorLabel={emailError?.email}
                      placeholder={trans("form:email")}
                      type="email"
                      value={request.email}
                      name='email'
                      onChangeValue={e => setRequest(prev => ({ ...prev, email: e.target.value }))}
                      title={trans("form:email")}
                    />

                  </div>
                  <div className="nice-col-md-6 my-5">
                    <InputField
                      value={request.password}
                      name="password"
                      type="password"
                      onChangeValue={e => setRequest(prev => ({ ...prev, password: e.target.value }))}
                      title={trans("form:password")}
                    />
                  </div>
                  <div className="nice-col-md-6 my-5">
                    <FormButton
                      isPrimary
                      isLoading={loading}
                      classes="px-5 py-2"
                      name={trans("user:deleteConfirmation")}
                      onClick={handleDeleteAccount}
                      disabled={!request.password}
                    />
                  </div>
                </SectionHeading>
              </TabPanel>

            </Tabs>
          </div>
        </SectionHeading>


      </div>
    </div>
  );
};
